<app-new-comment
  class="mb-6"
  [orgaUsers]="orgaUsers"
  (createNewComment)="createNewComment.emit($event)"
></app-new-comment>

<div class="flex flex-col gap-4 overflow-y-auto h-full">
  @for (comment of comments; track trackById($index, comment); let last = $last) {
    <app-comment
      [class.ml-8]="loggedInUserId === comment.data.authorUserId"
      [class.mr-8]="loggedInUserId !== comment.data.authorUserId"
      [comment]="comment"
      [last]="last"
      [loggedInUserId]="loggedInUserId"
      (deleteComment)="deleteComment.emit($event)"
      (markAsReacted)="markAsReacted.emit($event)"
    ></app-comment>
  }
</div>
